// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAe5pHdfxwHr4ljNiOSCC_G0raWaWQ_YeQ",
  authDomain: "nampa-ocia.firebaseapp.com",
  projectId: "nampa-ocia",
  storageBucket: "nampa-ocia.appspot.com",
  messagingSenderId: "1055972171757",
  appId: "1:1055972171757:web:0de6a8b550189e757bd1e4",
  measurementId: "G-R369PGEJQY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const storage = getStorage();

  
